import { render, staticRenderFns } from "./mails.vue?vue&type=template&id=214d77ea"
import script from "./mails.vue?vue&type=script&lang=js"
export * from "./mails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports